import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "barracuda",
  "use": "barracuda-usage",
  "viewBox": "0 0 134.95 98.62",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 134.95 98.62\" id=\"barracuda\"><path fill=\"#0088ce\" d=\"M26.24 98.62H0C0 57 11 30.56 11 30.56 7.54 75.34 26.24 98.62 26.24 98.62M134.95 0S51.64 32.9 36.19 98.62h70.13S56 85.43 134.95 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol